// test-ids

export const HOTEL_MAP_CONTAINER_TEST_ID = 'hotel-map-container';
